import Sidebar from "../../../components/sidebar/Sidebar"
import Navbar from "../../../components/navbar/Navbar"
import "../../Patient/list.scss"
import BedTable from "./bedTable"

const BedTableContainer = () => {

 
  return (
    <div className="list">
      <Sidebar />
      <div className="listContainer">
        <Navbar />
        <>
            <BedTable />
        </>
      </div>
    </div>
  )
}

export default BedTableContainer